import axios from 'axios';
import { TRANSMISSION_TYPE } from 'src/interfaces/enums';

const toggle = {
  ENABLE_PLAYER_EXPERIMENTAL_ABR: 'ABR',
  ENABLE_PLAYER_DEVICE_PIXEL_RATIO: 'DEVICE_RATIO',
  ENABLE_PLAYER_LOW_INITIAL_PLAYLIST: 'INIT_LOW_RESOLUTION',
  ENABLE_PLAYER_LIMIT_RENDITION_DIMENSIONS: 'LIMIT_RENDITION',
};

export const extractMuxToggles = (flags) => {
  const result: string[] = [];
  Object.keys(toggle).forEach((key) => flags[key] && result.push(toggle[key]));
  return `${result.join(', ')}`;
};

export const extractMuxCdn = async (applicationData) => {
  try {
    if (applicationData?.transmissionType === TRANSMISSION_TYPE.live) {
      const data = await axios.get(applicationData?.mediaAssets[0].url);
      const cdn = data.headers['x-cdn'];
      const match = cdn.match(/(.*?);/);
      const result = match ? match[1] : null;
      return `mux-${result}`;
    }
    return null;
  } catch (error) {
    return null;
  }
};
